export default "__VITE_PUBLIC_ASSET__b4f5dfd7__"